
  import {defineComponent} from "vue";
  import {mapState} from "vuex";
  import paycoUtils from "@/assets/js/utils";

  export default defineComponent({
    name: 'product-notice-component',
    computed: {
      ...mapState({
        product: (state: any) => state.ProductStore.product,
      })
    },
    data() {
      return {
        showNotice: false
      }
    },
    methods: {
      toggleNotice(): void {
        this.showNotice = !this.showNotice;
      },
      convertToMultiLineString(noticeDescription: string): Array<string> {
        if (paycoUtils.isEmptyString(noticeDescription)) {
          return [];
        }
        return paycoUtils.splitByNewline(noticeDescription);
      },
      hasNewlineCharacter(noticeDescription: string): boolean {
        return paycoUtils.hasNewlineCharacter(noticeDescription);
      }
    }
  });
